export const ConfirmationStepTexts = {
  popupTitle: 'Введите код из СМС',
  popupSubTitle: 'Так вы подтверждаете доставку карты.',
};
